import { render, staticRenderFns } from "./addInvoiceAddressDialog.vue?vue&type=template&id=4b59299c&scoped=true"
import script from "./addInvoiceAddressDialog.vue?vue&type=script&lang=js"
export * from "./addInvoiceAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./addInvoiceAddressDialog.vue?vue&type=style&index=0&id=4b59299c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59299c",
  null
  
)

export default component.exports